import React, { useEffect, useState } from "react";
import Loading from "../../../Shear/Loading/Loading";
import OrderItem from "./OrderItem";

const Order = (props) => {
  const [userData, setUserData] = useState([]);
  const [load, setLoad] = useState(false);
  const [update, setUpdate] = useState(false);
  useEffect(() => {
    setLoad(true);
    fetch("https://itghar-back.onrender.com/order", {
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then((response) => response.json())
      .then((json) => {
        setUserData(json);
        setLoad(false);
      });
  }, [update]);

  const orders = userData?.filter((order) => order.status === false);

  return (
    <div>
      {load ? (
        <Loading />
      ) : (
        <div className="container mx-auto px-4 sm:px-8 font-fira">
          <div className="py-8">
            <div>
              <h2 className="text-2xl font-semibold leading-tight font-fira">
                Admissions
              </h2>
            </div>
            <div className="-mx-4 max-sm:-mx-8 px-4 max-sm:px-8 py-4 overflow-x-auto">
              <div className="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
                <table className="min-w-full leading-normal">
                  <thead>
                    <tr>
                      <th className="px-5 py-3 border-b-2 border-[#e5e7eb] bg-[#f3f4f6] text-left text-xs font-semibold text-[#374151] uppercase tracking-wider">
                        No
                      </th>
                      <th className="px-5 py-3 border-b-2 border-[#e5e7eb] bg-[#f3f4f6] text-left text-xs font-semibold text-[#374151] uppercase tracking-wider">
                        Course
                      </th>
                      <th className="px-5 py-3 border-b-2 border-[#e5e7eb] bg-[#f3f4f6] text-left text-xs font-semibold text-[#374151] uppercase tracking-wider">
                        Contact No
                      </th>
                      <th className="px-5 py-3 border-b-2 border-[#e5e7eb] bg-[#f3f4f6] text-left text-xs font-semibold text-[#374151] uppercase tracking-wider">
                        trxID
                      </th>
                      <th className="px-5 py-3 border-b-2 border-[#e5e7eb] bg-[#f3f4f6] text-left text-xs font-semibold text-[#374151] uppercase tracking-wider">
                        Status
                      </th>
                    </tr>
                  </thead>
                  {orders?.map((data, index) => (
                    <OrderItem
                      key={index}
                      setUpdate={setUpdate}
                      data={data}
                      index={index}
                    />
                  ))}
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Order;
